<script setup lang="ts">
const { company } = useCompany()
</script>

<template>
  <Container
    v-if="company.stats"
    class="screen-content relative grid grid-cols-2 items-center justify-center gap-8 py-8 md:flex"
  >
    <div v-for="stats of company.stats" :key="stats.title" class="relative text-center md:text-left">
      <Paragraph as="h2" size="small" class="!text-gray-500 md:!text-left">{{ stats.title }}</Paragraph>
      <Heading as="p" size="medium">{{ stats.data }}</Heading>
    </div>

    <div class="pointer-events-none absolute mx-auto h-full w-full max-w-xl">
      <div
        class="bg-radial-gradient-main absolute bottom-0 left-0 h-full w-full origin-bottom scale-[3] md:scale-100 md:scale-x-[1.75]"
      />
      <div class="bg-gradient-main absolute bottom-0 left-0 h-px w-full scale-x-150 md:scale-x-100" />
    </div>
  </Container>
</template>
